<template>
    <v-container class="container" fluid>
        <iframe
            src="https://www.google.com/maps/d/viewer?mid=1CF2gk6YW4TsPNqHf1ih5y5AaAv6zHP2k&ll=47.14964031784158%2C-93.88052554999999&z=4"
            width="100%"
            height="800"
        ></iframe>
    </v-container>
</template>

<script>
export default {
    name: 'MapLoader',
    data: function() {
        return {};
    }
};
</script>
